export type ContentfulCallToAction = {
  __typename: 'ContentfulCallToAction';
  id: string;
  innerLink: string | null;
  text: string | null;
};

export type ContentfulPage = {
  __typename: 'ContentfulPage';
  id: string;
  slug: string | null;
  title: string | null;
};

export type NavigationItem = ContentfulCallToAction | ContentfulPage;

export function isContentfulPage(item: NavigationItem | {}): item is ContentfulPage {
  return (item as NavigationItem).__typename === 'ContentfulPage';
}

export function isContentfulCallToAction(item: NavigationItem | {}): item is ContentfulCallToAction {
  return (item as NavigationItem).__typename === 'ContentfulCallToAction';
}

export function isNavigationItem(item: NavigationItem | {}): item is NavigationItem {
  return isContentfulPage(item) || isContentfulCallToAction(item);
}
